/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable no-param-reassign */

import { useEffect } from 'react';

const useAutosizeTextArea = (
  textAreaRef: HTMLTextAreaElement | HTMLDivElement | null,
  value?: string,
  isScrollArea?: boolean,
  isGeneratedEmailView?: boolean,
) => {
  const checkHeight = isGeneratedEmailView ? 180 : 140;
  useEffect(() => {
    if (textAreaRef) {
      textAreaRef.style.height = '0px';
      const { scrollHeight } = textAreaRef;
      isScrollArea
        ? textAreaRef.style.height = `calc(100vh - ${scrollHeight / 2}px)`
        : textAreaRef.style.height = `${scrollHeight}px`;
      if (scrollHeight >= checkHeight) {
        textAreaRef?.classList.add('maxOverflow');
      } else if (scrollHeight <= checkHeight) {
        textAreaRef?.classList.remove('maxOverflow');
      }
    }
  }, [textAreaRef, value]);
};

export default useAutosizeTextArea;
